module.exports = __webpack_public_path__ + "img/jiangbei_s.e3f0918.png";